<form [formGroup]="form">
  <ion-row class="revenue-config-row">
    <ion-col size="4">
      <app-form-input-field
        formControlName="maxDimension"
        [maxLength]="5"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MAX_DIMENSION"
        [suffix]="getUnit('dimension')"
      ></app-form-input-field>
    </ion-col>
    <ion-col size="4" push="1">
      <app-form-input-field
        formControlName="minDimension"
        [maxLength]="5"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MIN_DIMENSION"
        [suffix]="getUnit('dimension')"
      ></app-form-input-field>
    </ion-col>
  </ion-row>
  <ion-row class="revenue-config-row">
    <ion-col size="4">
      <app-form-input-field
        formControlName="maxGirthDimension"
        [maxLength]="5"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MAX_GIRTH"
        [suffix]="getUnit('length')"
      ></app-form-input-field>
    </ion-col>
    <ion-col size="4" push="1">
      <app-form-input-field
        formControlName="minGirthDimension"
        [maxLength]="5"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MIN_GIRTH"
        [suffix]="getUnit('length')"
      ></app-form-input-field>
    </ion-col>
  </ion-row>
  <ion-row class="revenue-config-row">
    <ion-col size="4">
      <app-form-input-field
        formControlName="maxWeight"
        [maxLength]="6"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MAX_WEIGHT"
        [suffix]="getUnit('weight')"
      ></app-form-input-field>
    </ion-col>
    <ion-col size="4" push="1">
      <app-form-input-field
        formControlName="minWeight"
        [maxLength]="6"
        [regexType]="REGEX"
        [inputType]="'number'"
        [label]="CONSTANTS.MIN_WEIGHT"
        [suffix]="getUnit('weight')"
      ></app-form-input-field>
    </ion-col>
  </ion-row>
</form>
